import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4 whitespace-nowrap">白丝文化指南</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              探索白丝的多元文化内涵与时尚潮流，为白丝爱好者提供最全面的参考资讯，发现属于你的白丝美学与个性表达。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">内容分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">热门文章</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/baisi-origin-history" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  白丝的起源与历史演变
                </Link>
              </li>
              <li>
                <Link to="/article/baisi-jk-uniform" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  白丝与JK制服搭配攻略
                </Link>
              </li>
              <li>
                <Link to="/article/baisi-how-to-choose" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  如何挑选白丝终极指南
                </Link>
              </li>
              <li>
                <Link to="/article/baisi-photography-art" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  白丝摄影艺术与视觉美学
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-200/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 白丝文化指南. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}